export default __webpack_public_path__ + "static/media/r-logo.c2ce5c68.png";